import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NotesComponent } from './notes.component';
import { NoteItemComponent } from './note-item.component';
import { MomentModule } from 'ngx-moment';
import { NotesService } from './notes.service';
import { PipesModule } from '../../../pipes/pipes.module';
import { DirectiveModule } from '../directives/directives.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

@NgModule({ declarations: [
        NotesComponent,
        NoteItemComponent
    ],
    exports: [
        NotesComponent
    ], imports: [CommonModule,
        FormsModule,
        MomentModule,
        PipesModule,
        DirectiveModule], providers: [NotesService, provideHttpClient(withInterceptorsFromDi())] })
export class NotesModule {
}
